/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Discarded_ToastInputs */

const en_us2_draft_discarded_toast = /** @type {(inputs: Draft_Discarded_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft discarded`)
};

const pt_br2_draft_discarded_toast = /** @type {(inputs: Draft_Discarded_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rascunho descartado`)
};

const es_419_draft_discarded_toast = /** @type {(inputs: Draft_Discarded_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrador descartado`)
};

const pt_pt2_draft_discarded_toast = /** @type {(inputs: Draft_Discarded_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rascunho descartado`)
};

const fr_fr2_draft_discarded_toast = /** @type {(inputs: Draft_Discarded_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brouillon abandonné`)
};

const de_de2_draft_discarded_toast = /** @type {(inputs: Draft_Discarded_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwurf verworfen`)
};

const it_it2_draft_discarded_toast = /** @type {(inputs: Draft_Discarded_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bozza scartata`)
};

/**
* | output |
* | --- |
* | "Draft discarded" |
*
* @param {Draft_Discarded_ToastInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_discarded_toast = /** @type {((inputs?: Draft_Discarded_ToastInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Discarded_ToastInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_discarded_toast(inputs)
	if (locale === "es-419") return es_419_draft_discarded_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_discarded_toast(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_discarded_toast(inputs)
	if (locale === "de-DE") return de_de2_draft_discarded_toast(inputs)
	if (locale === "it-IT") return it_it2_draft_discarded_toast(inputs)
	return en_us2_draft_discarded_toast(inputs)
});
export { draft_discarded_toast as "draft.discarded_toast" }